import * as React from 'react'
import { Link } from 'react-router-dom'
import classNames from 'classnames'
import { SkeletonBar } from 'uiComponents/skeleton/skeleton'

interface CapacityRowProps {
    href: string
    name: string
    detail?: string
    pending?: boolean
}

export function CapacityRow({ href, name, detail, pending }: CapacityRowProps) {
    return (
        <div className="capacity-section-row">
            <span className="capacity-section-row-text">
                <Link className="capacity-section-link" to={href}>
                    {name}
                </Link>
                {detail && <span className="capacity-section-detail">· {detail}</span>}
                {pending && <SkeletonBar width="11rem" height="0.8rem" className="capacity-section-ghost" />}
            </span>
        </div>
    )
}

export function MessageRow({ text }: { text: string }) {
    return (
        <div className="capacity-section-row">
            <span className="capacity-section-detail">{text}</span>
        </div>
    )
}

export function PendingRow() {
    return (
        <div className="capacity-section-row" aria-busy="true">
            <SkeletonBar width="11rem" height="0.8rem" className="capacity-section-ghost" />
        </div>
    )
}

interface LinesRowProps {
    lines: string[]
    linkTo?: string
    linkLabel?: string
}

export function LinesRow({ lines, linkTo, linkLabel }: LinesRowProps) {
    return (
        <div className={classNames('capacity-section-row', 'capacity-section-row-lines')}>
            <span className="capacity-section-lines">
                {lines.map((line) => (
                    <span key={line} className="capacity-section-detail">
                        {line}
                    </span>
                ))}
            </span>
            {linkTo && linkLabel && (
                <Link className="capacity-section-link" to={linkTo}>
                    {linkLabel}
                </Link>
            )}
        </div>
    )
}
